<template>
  <div>
    <h2>Result</h2>
      {{result}}
  </div>
</template>
<script>

  import { ListActivitiesForCurrentUser } from '@/components/queries'

  export default {
    data() {
      return {
        result: {}
      }
    },
    methods: {
      async fetchActivities() {
        const params = {
          variables: {
            actDate: "1547874000000"
          },
          query: ListActivitiesForCurrentUser
        }
        const result = await this.$apollo.query(params);
        this.result = result
      }
    },
    async mounted() {
      await this.fetchActivities();
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/DevTmp.vue